import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';

export interface UrlTab {
    id: string;
    label: string;
    panel: ReactNode;
}

/** Underline tabs; the selected tab lives in `?tab=`. Unknown values fall back to the first tab. */
export const UrlTabs = ({ tabs, label }: { tabs: UrlTab[]; label: string }) => {
    const [params, setParams] = useSearchParams();
    const found = tabs.findIndex((t) => t.id === params.get('tab'));
    const index = found < 0 ? 0 : found;
    const select = (i: number) =>
        setParams(
            (prev) => {
                const next = new URLSearchParams(prev);
                if (i === 0) next.delete('tab');
                else next.set('tab', tabs[i].id);
                next.delete('page');
                return next;
            },
            { replace: true }
        );
    return (
        <TabGroup selectedIndex={index} onChange={select}>
            <TabList aria-label={label} className="-mx-gutter mb-6 flex overflow-x-auto border-b border-hairline px-gutter">
                {tabs.map((t) => (
                    <Tab
                        key={t.id}
                        className={clsx(
                            'min-h-11 shrink-0 whitespace-nowrap border-b-2 px-4 text-small font-semibold -mb-px focus-visible:outline-offset-[-2px]',
                            'data-[selected]:border-inverse data-[selected]:text-strong border-transparent text-muted hover:text-strong'
                        )}
                    >
                        {t.label}
                    </Tab>
                ))}
            </TabList>
            <TabPanels>
                {tabs.map((t) => (
                    <TabPanel key={t.id}>{t.panel}</TabPanel>
                ))}
            </TabPanels>
        </TabGroup>
    );
};
